export function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export function between(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

export function highestId(data, idField = "id"): number {
  if (!data) {
    return -1;
  }

  if (data.length === 0) {
    return 1;
  }

  const highestId = data.reduce((accumulator, currentValue) => {
    if (currentValue[idField] > accumulator) {
      return currentValue[idField];
    }
    return accumulator;
  }, 0);

  return highestId;
}

export function createUserGroups(user, groups) {
  groups.forEach((group) => {
    if (group.includes("custom")) {
      if (!user.custom_groups.includes(group)) {
        user.custom_groups.push(group);
      }
    } else {
      if (!user.system_groups.includes(group)) {
        user.system_groups.push(group);
      }
    }
  });

  return user;
}

export function deleteUserGroup(user, group) {
  if (group.includes("custom")) {
    const index = user.custom_groups.indexOf(group);
    if (index > -1) {
      user.custom_groups.splice(index, 1);
    }
  } else {
    const index = user.system_groups.indexOf(group);
    if (index > -1) {
      user.system_groups.splice(index, 1);
    }
  }

  return user;
}

export function updateUser(user, body) {
  if (body.name) {
    user.name = body.name;
  }

  if (body.username) {
    user.username = body.username;
  }

  if (body.email) {
    user.email = body.email;
  }

  // Can't check for falsey, since an empty string is a valid value
  if (isSet(body.preferred_username)) {
    user.preferred_username = body.preferred_username;
  }

  if (body.aws_keypair_name) {
    user.aws_keypair_name = body.aws_keypair_name;
  }

  // Is a boolean, can't blindly use falsey since "false" is a valid value
  if (isSet(body.active)) {
    user.active = body.active;
  }

  return user;
}

function isSet(value) {
  if (value === undefined || value === null) {
    return false;
  }

  return true;
}

export function searchAndDelete<T>(data: Array<T>, idKey, findId): boolean {
  let foundIndex = -1;

  foundIndex = data.findIndex((entry) => {
    return entry[idKey] === findId;
  });

  if (foundIndex != -1) {
    data = data.splice(foundIndex, 1);
    return true;
  }

  return false;
}

export function searchAndReplace<T>(data: Array<T>, idKey, findId, replace: T): boolean {
  let foundIndex = -1;

  foundIndex = data.findIndex((entry) => {
    return entry[idKey] === findId;
  });

  if (foundIndex != -1) {
    data = data.splice(foundIndex, 1);
    data.push(replace);
    return true;
  }

  return false;
}
